import styled from 'styled-components';
import FlexContainer, { FlexContainerProps } from './FlexContainer';

const ContainerWrapper = styled(FlexContainer)<FlexContainerProps>`
  width: 100%;
  gap: ${(p) => p.theme.spacing.md};
  padding: ${(p) => p.theme.spacing.md};
  @media (max-width: ${(p) => p.theme.screen.xl}) {
    padding: ${(p) => p.theme.spacing.xxs};
  }
  @media (max-width: ${(p) => p.theme.screen.md}) {
    flex-direction: column;
  }
`;

export default ContainerWrapper;
